var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48131 13.7196C4.30234 14.4216 1.21114 15.855 3.09389 17.6487C4.01359 18.5249 5.03791 19.1516 6.32573 19.1516H13.6743C14.9621 19.1516 15.9864 18.5249 16.9061 17.6487C18.7888 15.855 15.6977 14.4216 14.5187 13.7196C11.754 12.0733 8.24599 12.0733 5.48131 13.7196Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.23486C13.75 8.30593 12.0711 9.98486 10 9.98486C7.92893 9.98486 6.25 8.30593 6.25 6.23486C6.25 4.1638 7.92893 2.48486 10 2.48486C12.0711 2.48486 13.75 4.1638 13.75 6.23486Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8e8f4052da72851d5b13e902a942967a.svg";
export { ForwardRef as ReactComponent };